import { render, staticRenderFns } from "./CompanyDeliverySettingsDialog.vue?vue&type=template&id=a7536c52"
import script from "./CompanyDeliverySettingsDialog.vue?vue&type=script&lang=js"
export * from "./CompanyDeliverySettingsDialog.vue?vue&type=script&lang=js"
import style0 from "./CompanyDeliverySettingsDialog.vue?vue&type=style&index=0&id=a7536c52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports